import { useQuery, keepPreviousData } from '@tanstack/react-query';
import type { NotificationListResponse } from '@troia-v3/types';

import { api } from '@/lib/api';

/** Itens por página do log (fixo — a página não expõe seletor de tamanho). */
export const NOTIFICATIONS_LOG_PAGE_SIZE = 20;

export interface NotificationsLogParams {
  page: number;
  /** ISO datetime (início do dia local) */
  dateFrom?: string;
  /** ISO datetime (fim do dia local) */
  dateTo?: string;
  type?: string;
  /** email | whatsapp | push | inApp | sound */
  channel?: string;
}

/**
 * Log de notificações do usuário — `GET /notifications/my` com
 * `includeAllChannels=true` (o default da rota é o "bell filter", que só
 * devolve o que passou pelo canal `inApp`; aqui queremos TODOS os canais).
 *
 * `placeholderData: keepPreviousData` mantém a página anterior visível durante
 * a troca de página/filtro (sem flash de loading na tabela).
 */
export const useNotificationsLog = (params: NotificationsLogParams) =>
  useQuery({
    queryKey: ['notifications', 'log', params],
    queryFn: async ({ signal }) => {
      const response = await api.get<{ success: boolean; data: NotificationListResponse }>(
        'notifications/my',
        {
          signal,
          params: {
            includeAllChannels: 'true',
            limit: NOTIFICATIONS_LOG_PAGE_SIZE,
            page: params.page,
            ...(params.dateFrom ? { dateFrom: params.dateFrom } : {}),
            ...(params.dateTo ? { dateTo: params.dateTo } : {}),
            ...(params.type ? { type: params.type } : {}),
            ...(params.channel ? { channel: params.channel } : {}),
          },
        },
      );
      return response.data.data;
    },
    placeholderData: keepPreviousData,
  });
